import "./skeleton.scss";
import { TableColumn } from "react-data-table-component";

interface ISkeletonTableProps<T> {
  rows?: number; // number of rows
  columns: TableColumn<T>[]; // actual table columns
  rowHeight?: number;
  gap?: number; // space between columns
  rowGap?: number; // space between rows
}

const SkeletonTable = <T,>({
  rows = 8,
  columns,
  rowHeight = 40,
  gap = 8,
  rowGap = 8,
}: ISkeletonTableProps<T>) => {
  return (
    <div
      className="skeleton-table w-100"
      style={{ display: "flex", flexDirection: "column", gap: `${rowGap}px` }}
    >
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          className={`skeleton-row d-flex mx-1 ${
            Number(rowIndex) === 0 ? "mt-1" : ""
          } ${Number(rows) === Number(rowIndex) + 1 ? "mb-1" : ""} `}
          style={{ gap: `${gap}px` }}
        >
          {columns.map((col, colIndex) => {
            let width: string | undefined = undefined;
            let flexGrow = col.grow ?? 1;

            if (col.width) {
              if (typeof col.width === "string") {
                width = col.width;
                flexGrow = 0;
              } else if (typeof col.width === "number") {
                width = `${col.width}px`;
                flexGrow = 0;
              }
            }

            return (
              <div
                key={colIndex}
                className="skeleton-cell"
                style={{
                  width,
                  height: rowHeight,
                  flexGrow,
                }}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default SkeletonTable;
